import { DIAS_DA_FOLGA, diaDaSemana, diasDoPeriodo, inicioDaSemana, somarDias } from '../../escala';
import type { FolgaFixa, MudancaDeCelula, TurnoDaEscala } from '../../escala';

/**
 * FOLGA FIXA no front (só para a prévia e o resumo). Cópia da regra de @inovapay/domain
 * (celulasDaFolgaFixa) — quem grava é o servidor, com a regra de lá; o teste de paridade em
 * apps/web/tests/folga-fixa.test.ts garante que as duas dizem a mesma coisa.
 */

function semanaDoDomingo(f: FolgaFixa, dia: string): boolean {
  if (f.modo !== 'FIXA_DOMINGO' || !f.domingoBase) return false;
  const domingo = somarDias(inicioDaSemana(dia), 6);
  const semanas = Math.round(
    (Date.parse(`${domingo}T12:00:00Z`) - Date.parse(`${f.domingoBase}T12:00:00Z`)) /
      (7 * 86_400_000),
  );
  const n = Math.max(2, f.cicloDomingo);
  return ((semanas % n) + n) % n === 0;
}

export function celulasDaFolgaFixaWeb(
  f: FolgaFixa,
  de: string,
  ate: string,
  feriados: ReadonlySet<string> = new Set(),
): MudancaDeCelula[] {
  const out: MudancaDeCelula[] = [];
  for (const dia of diasDoPeriodo(de, ate)) {
    const w = diaDaSemana(dia);
    let folga: boolean;
    if (f.modo === 'DIAS') folga = f.diasFixos.includes(w);
    else if (w === 0) {
      if (f.modo === 'FIXA') {
        if (!f.trabalhaFeriado && feriados.has(dia)) out.push({ pessoaId: '', dia, turno: 'FR' });
        continue;
      }
      folga = semanaDoDomingo(f, dia);
    } else folga = w === f.dia && (f.folgaDupla || !semanaDoDomingo(f, dia));
    const turno = folga ? 'F' : !f.trabalhaFeriado && feriados.has(dia) ? 'FR' : f.turnoPadrao;
    if (turno) out.push({ pessoaId: '', dia, turno });
  }
  return out;
}

export function resumoDaFolgaFixa(f: FolgaFixa, turnos: readonly TurnoDaEscala[]): string {
  const dia = DIAS_DA_FOLGA[f.dia] ?? '';
  const t = f.turnoPadrao ? turnos.find((x) => x.codigo === f.turnoPadrao)?.rotulo : null;
  const nomes = ['domingo', ...DIAS_DA_FOLGA.slice(1)];
  const base =
    f.modo === 'DIAS'
      ? `Folga ${[...f.diasFixos]
          .sort((a, b) => ((a + 6) % 7) - ((b + 6) % 7))
          .map((d) => nomes[d] ?? '')
          .join(' e ')}`
      : f.modo === 'FIXA_DOMINGO'
        ? `Folga ${dia} + 1 domingo a cada ${String(f.cicloDomingo)}${f.folgaDupla ? ' (folga dupla)' : ''}`
        : `Folga ${dia} · domingo na mão`;
  const comTurno = t ? `${base} · ${t}` : base;
  return f.trabalhaFeriado ? comTurno : `${comTurno} · não trabalha feriado`;
}

const DIA_CURTO = ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'];
export const diaCurtoDaSemana = (dia: string) => DIA_CURTO[diaDaSemana(dia)] ?? '';

export function proximoDomingo(hoje: string): string {
  return somarDias(hoje, (7 - diaDaSemana(hoje)) % 7);
}
